import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import MuiCheckbox from '@mui/material/Checkbox';
import { styled, alpha } from '@mui/material/styles';
import { ReactComponent as ForwardRef$3 } from '../../assets/icons/SelectAllSemiCheckboxSmall.svg.js';
import { ReactComponent as ForwardRef } from '../../assets/icons/SelectAllCheckboxSmall.svg.js';
import { ReactComponent as ForwardRef$2 } from '../../assets/icons/FullCheckboxSmall.svg.js';
import { ReactComponent as ForwardRef$1 } from '../../assets/icons/CheckboxSmall.svg.js';
import Label from '../Label/Label.js';
import Hint from '../Hint/Hint.js';

const _Checkbox = styled(MuiCheckbox, {
    shouldForwardProp: prop => !['rtl'].includes(prop),
}) `
  ${({ theme, rtl }) => `
    margin: ${rtl ? theme.spacing(0, -0.25, 0, 0) : theme.spacing(0, 0, 0, 0.5)};
    display: flex;
  `}
`;
const _Label = styled(Label) `
  ${({ theme, disabled }) => !disabled &&
    `
    :hover, :focus {
      .MuiCheckbox-root {
        path {
          fill: ${theme.palette.primary.main};
        }
        background-color: ${alpha(theme.palette.primary.main, 0.2)};
      }
    } 
  `}
`;
const Checkbox = (_a, ref) => {
    var { selectAll, disabled, children, semi, className, hint, hintDuration, rtl, ['data-testid']: testId } = _a, rest = __rest(_a, ["selectAll", "disabled", "children", "semi", "className", "hint", "hintDuration", "rtl", 'data-testid']);
    const CheckboxComponent = (jsx(Hint, Object.assign({ title: hint, duration: hintDuration }, { children: jsx(_Checkbox, Object.assign({ icon: selectAll ? jsx(ForwardRef, {}) : jsx(ForwardRef$1, {}), checkedIcon: jsx(ForwardRef$2, {}), rtl: rtl, indeterminateIcon: jsx(ForwardRef$3, {}), indeterminate: selectAll && semi && !rest.checked, disabled: disabled, ref: ref, "data-testid": testId }, rest)) })));
    if (!children) {
        return CheckboxComponent;
    }
    return (jsx(_Label, Object.assign({ disabled: disabled, className: className, hint: hint, hintDuration: hintDuration, labelVariant: selectAll ? 'body2' : 'body1', control: CheckboxComponent }, { children: children })));
};
var Checkbox$1 = React__default.forwardRef(Checkbox);

export { Checkbox$1 as default };
//# sourceMappingURL=Checkbox.js.map
